import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgHomeFunBulk = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="m19.919 7.625-5.573-4.54a3.72 3.72 0 0 0-4.692 0L4.083 7.624a3.68 3.68 0 0 0-1.37 2.873v7.18a4.075 4.075 0 0 0 4.07 4.07h10.432a4.075 4.075 0 0 0 4.072-4.07v-7.18a3.68 3.68 0 0 0-1.368-2.872"
      opacity={0.4}
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.106 14.894c-1.028 1.336-2.524 2.103-4.105 2.103-1.58 0-3.076-.766-4.105-2.103a.749.749 0 1 1 1.189-.915c.742.965 1.805 1.518 2.916 1.518s2.174-.553 2.916-1.517a.75.75 0 0 1 1.189.914"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgHomeFunBulk);
export default ForwardRef;
